import { Link } from 'react-router-dom';
export const NotFoundPage = () => (
  <div className="flex min-h-[60vh] flex-col items-center justify-center gap-4 text-center">
    <div>
      <p className="text-sm uppercase tracking-[0.3em] text-muted-foreground">404</p>
      <h2 className="text-2xl font-semibold">Page not found</h2>
      <p className="text-sm text-muted-foreground">The page you are looking for doesn't exist.</p>
    </div>
    <Link
      to="/repos"
      className="inline-flex items-center justify-center rounded-md border border-border px-4 py-2 text-sm font-medium transition-colors hover:bg-muted"
    >
      Back to repositories
    </Link>
  </div>
);
